import PropTypes from "prop-types";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { capitalize } from "../../utils/manipulateText";

const normalizeHex = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  const withoutHash = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
  const cleaned = withoutHash.replace(/[^0-9a-fA-F]/g, "").slice(0, 6);
  return cleaned ? `#${cleaned.toUpperCase()}` : "";
};

const ColorInput = ({ name, label, value, onChange, className = "" }) => {
  const { t } = useTranslation();
  const colorPickerRef = useRef(null);

  const emit = (next) => {
    onChange?.({ target: { name, value: next } });
  };

  const handleHexChange = (e) => {
    const next = normalizeHex(e.target.value);
    emit(next);
  };

  const handleColorChange = (e) => {
    const next = e.target.value;
    emit(normalizeHex(next));
  };

  const handleHexBlur = (e) => {
    const next = normalizeHex(e.target.value);
    emit(next);
  };

  const hex = value || "";

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label
          className="block text-gray-700 text-sm font-bold mb-2"
          htmlFor={name}
        >
          {capitalize(t(label))}
        </label>
      )}
      <div className="flex items-center border border-gray-300 hover:border-gray-400 focus-within:border-indigo-500 rounded-lg px-3 py-2 bg-white transition-colors duration-150 ease-in-out shadow-sm">
        <div className="relative w-8 h-8 mr-3">
          <div
            className="w-8 h-8 rounded-lg border border-gray-200"
            style={{ backgroundColor: hex || "#000000" }}
          />
          <input
            ref={colorPickerRef}
            id={`${name}-picker`}
            type="color"
            value={hex || "#000000"}
            onChange={handleColorChange}
            className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
          />
        </div>
        <input
          id={name}
          name={name}
          type="text"
          value={normalizeHex(hex)}
          onChange={handleHexChange}
          onBlur={handleHexBlur}
          onClick={() => colorPickerRef.current?.click()}
          placeholder="#000000"
          className="bg-transparent border-0 outline-none focus:ring-0 text-base text-gray-800 placeholder-gray-500 w-full tracking-wide"
        />
      </div>
    </div>
  );
};

ColorInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default ColorInput;
